"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialValues = exports.generateStyle = exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _palette = _interopRequireDefault(require("./palette.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validate = function validate(values) {
  var errors = {};
  return errors;
};
var generateStyle = exports.generateStyle = function generateStyle(values) {
  var _values$marginTop, _values$marginBottom, _values$marginLeft, _values$marginRight;
  var parts = [];
  if (['left', 'right'].includes(values["float"])) {
    parts.push("float: ".concat(values["float"], ";"));
  }
  if ((_values$marginTop = values.marginTop) !== null && _values$marginTop !== void 0 && _values$marginTop.trim()) {
    parts.push("margin-top: ".concat(values.marginTop.trim(), ";"));
  }
  if ((_values$marginBottom = values.marginBottom) !== null && _values$marginBottom !== void 0 && _values$marginBottom.trim()) {
    parts.push("margin-bottom: ".concat(values.marginBottom.trim(), ";"));
  }
  if ((_values$marginLeft = values.marginLeft) !== null && _values$marginLeft !== void 0 && _values$marginLeft.trim()) {
    parts.push("margin-left: ".concat(values.marginLeft.trim(), ";"));
  }
  if ((_values$marginRight = values.marginRight) !== null && _values$marginRight !== void 0 && _values$marginRight.trim()) {
    parts.push("margin-right: ".concat(values.marginRight.trim(), ";"));
  }
  return parts.length > 0 ? "style=\"".concat(parts.join(' '), "\"") : '';
};
var getInitialValues = exports.getInitialValues = function getInitialValues(content) {
  var altMatch = content.match(/alt="([^"]+)"/);
  var floatMatch = content.match(/float:\s*(left|right)/);
  var marginLeftMatch = content.match(/margin-left:\s*([\d.\w]+)/);
  var marginRightMatch = content.match(/margin-right:\s*([\d.\w]+)/);
  var marginTopMatch = content.match(/margin-top:\s*([\d.\w]+)/);
  var marginBottomMatch = content.match(/margin-bottom:\s*([\d.\w]+)/);
  return {
    "float": floatMatch ? floatMatch[1] : 'none',
    alt: altMatch ? altMatch[1] : '',
    marginTop: marginTopMatch ? marginTopMatch[1] : '',
    marginBottom: marginBottomMatch ? marginBottomMatch[1] : '',
    marginLeft: marginLeftMatch ? marginLeftMatch[1] : '',
    marginRight: marginRightMatch ? marginRightMatch[1] : ''
  };
};
var floatOptions = [{
  value: 'none',
  label: 'None',
  settings: {
    marginLeft: '',
    marginRight: '',
    marginTop: '',
    marginBottom: ''
  }
}, {
  value: 'left',
  label: 'Image on left',
  settings: {
    marginLeft: '',
    marginRight: '1em',
    marginTop: '',
    marginBottom: '0.5em'
  }
}, {
  value: 'right',
  label: 'Image on right',
  settings: {
    marginLeft: '1em',
    marginRight: '',
    marginTop: '',
    marginBottom: '0.5em'
  }
}];
var ImageStyle = function ImageStyle(props) {
  var content = props.content,
    selectedContent = props.selectedContent,
    setContent = props.setContent,
    closeModal = props.closeModal;
  var onSubmit = function onSubmit(values) {
    var style = ' ' + generateStyle(values);
    var alt = values.alt ? " alt=\"".concat(values.alt.replace(/"/g, "'"), "\"") : '';
    var newContent = selectedContent.replace(/style="[^"]+"/, '').replace(/alt="[^"]+"/, '').replace('<img', "<img".concat(alt).concat(style));
    setContent(content.replace(selectedContent, newContent));
    closeModal();
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: getInitialValues(selectedContent),
    onSubmit: onSubmit,
    validate: validate,
    render: function render(_ref) {
      var setFieldValue = _ref.setFieldValue,
        setValues = _ref.setValues,
        values = _ref.values;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "float"
      }, function (_ref2) {
        var field = _ref2.field,
          form = _ref2.form;
        return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
          field: field,
          form: form,
          label: "Text wrap"
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          className: "btn-group"
        }, floatOptions.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("button", {
            key: item.value,
            type: "button",
            className: (0, _classnames["default"])('btn btn-secondary', item.value === field.value && 'active'),
            onClick: function onClick() {
              if (item.settings) {
                setValues(_objectSpread(_objectSpread(_objectSpread({}, values), item.settings), {}, _defineProperty({}, field.name, item.value)));
              } else {
                setFieldValue(field.name, item.value);
              }
            }
          }, item.label);
        }))));
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label"
      }, "Margin")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          gap: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "marginTop",
        component: _cccisdFormik.CccisdInput,
        label: "Top"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "marginBottom",
        component: _cccisdFormik.CccisdInput,
        label: "Bottom"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "marginLeft",
        component: _cccisdFormik.CccisdInput,
        label: "Left"
      }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "marginRight",
        component: _cccisdFormik.CccisdInput,
        label: "Right"
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "alt",
        component: _cccisdFormik.CccisdInput,
        label: "Alternative text"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit")));
    }
  });
};
ImageStyle.propTypes = {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  insertContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string,
  closeModal: _propTypes["default"].func
};
var _default = exports["default"] = {
  name: 'cccisdImageStyle',
  image: _palette["default"],
  tooltip: 'Style',
  title: 'Style',
  component: ImageStyle,
  disableCondition: function disableCondition(content, meta, currentElement, selection) {
    var regex = /^<img[^>]+\/>$/;
    return !selection || !regex.test(selection);
  }
};